import * as moment from 'moment';

export function convertFilesToSendForm(files: FileList): FormData {
  const fileToUpload = files.item(0);
  const formData: FormData = new FormData();
  formData.append('file', fileToUpload, fileToUpload.name);
  return formData;
}

export function checkImportFileFormat(fileName) {
  return fileName && (fileName.endsWith('.csv') || fileName.endsWith('.xlsx'));
}

export function formatRecordingFileName(event) {
  return `${moment(event.createdAt).format('YYYY-MM-DD_HHMMSS')}_${event.id}_recording.wav`;
}
